{
  "positionInfo": {
    "title": "Open Position",
    "type": "Type",
    "quantity": "Quantity",
    "quantityAndSharesPerContract": "Quantity (lot x100)",
    "currentCost": "Current cost",
    "profitabilityInDollar": "Profitability in $",
    "balanceSheet": "Balance sheet",
    "entryPrice": "Entry price",
    "profitabilityInPercent": "Profitability in %",
    "share": "Share, %",
    "dropdownTitle": "Position information",
    "currentPrice": "Current price",
    "profitToday": "Profit today",
    "profitAllTime": "Profit of all time",
    "USD": "USD",
    "side": {
      "buy": "Buy",
      "sell": "Sell"
    },
    "option": "Option",
    "strike": "Strike",
    "expiration": "Expiration",
    "assetsInfoFailed": "Failed to load option asset info"
  }
}
